export enum ExpeditionComputeRepartitionMode {
  MODE_PERCENTAGE_FROM_WEIGHT = 'PERCENTAGE_FROM_WEIGHT',
  MODE_WEIGHT_FROM_PERCENTAGE = 'WEIGHT_FROM_PERCENTAGE',
}
